import { VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../components/Button/Button';
import { ReadingGroupsPage as messages } from '../messages';

export const GroupDetailFooter: VFC = () => {
  const navigate = useNavigate();

  return (
    <Button block onClick={() => navigate('/reading-groups')}>
      <FormattedMessage {...messages.back} />
    </Button>
  );
};
